import { render } from "./characteristicValue.vue?vue&type=template&id=e202341c"
import script from "./characteristicValue.vue?vue&type=script&lang=js"
export * from "./characteristicValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__